<template>
	<div>
		<div class="d-flex align-items-center min-height-70vh">
			<div class="container d-flex justify-content-center">
				<div class="my-4" v-if="isLoading">
					<shimmer
						width="800px"
						height="500px"
					/>
				</div>
				<div class="card my-4 border-radius-8 max-width-800" v-if="privateOrder && !isLoading">
					<div class="card-header text-bold">
						<div class="text-center">
							<div class="card-headline">Terima kasih sudah melakukan order {{ productName }}</div>
						</div>
					</div>
					<div class="card-body">
						<div class="text-center mb-4">
							<div v-if="!isPaid && isOrderTypeOutsource">Untuk menyelesaikan proses order, silahkan transfer sejumlah</div>
							<div v-else-if="!isPaid && isOrderTypeBulky" class="fs-20 fw-600">
								<div>Pesanan Anda Telah Diterima!</div>
							</div>
							<div v-else class="fs-20 fw-600">Selamat, {{ paymentLabel }} berhasil!</div>

							<div class="my-4">
								<div v-if="isPaid && isOrderTypeOutsource">Total Bayar</div>
								<div v-if="isOrderTypeOutsource" class="text-success my-2 fs-20 fw-600">
									{{ getTotalPrice() }}
								</div>

								<div v-if="isPaid && !isOrderTypeBulky">Pesanan Anda akan segera kami proses</div>
								<div v-if="!isPaid && isOrderTypeBulky">
									<p>Order Anda sudah kami terima dan sedang dalam proses pengecekan. Mohon tunggu, Admin akan menyesuaikan rincian pesanan Anda untuk menambahkan biaya ongkir yang sesuai. Setelah proses penyesuaian selesai, kami akan menginformasikan total pembayaran terbaru pada menu <router-link to="/billings"><b>Billings</b></router-link>.</p>

									<div class="d-flex justify-content-center">
										<button @click="$router.push('/wholesale-order/list')" class="btn o-sm btn-outline outline-primary w-50">Cek Pesanan Anda</button>
									</div>
								</div>

								<button
									v-if="isOutsourceBankTransferUnpaid"
									class="btn btn-sm btn-outline-primary"
									@click="copyTotalPrice"
								>
									<i class="bi bi-copy"></i>
									<span>Salin Jumlah</span>
								</button>

								<button
									v-if="isInstantUnpaid && isOrderTypeOutsource"
									class="btn btn-sm btn-outline-primary"
									@click="pay"
								>
									<i class="bi bi-currency-dollar"></i>
									<span>Bayar</span>
								</button>
							</div>

							<div v-if="isOutsourceBankTransferUnpaid">ke rekening bank berikut ini :</div>
						</div>

						<div class="d-flex justify-content-center mb-4" v-if="isOutsourceBankTransferUnpaid">
							<div class="p-4 text-center border-grey border-radius-8">
								<img src="https://cdn.ostock.id/img/banks/bank-bca.png" width="50px" class="mb-2" />
								<div class="mb-2">No. Rek. {{ bankAccount.account_number }}</div>
								<div class="mb-2">Atas Nama: {{ bankAccount.account_name }}</div>
								<button
									class="btn btn-sm btn-outline-primary"
									@click="copyAccountNumber"
								>
									<i class="bi bi-copy"></i>
									<span>Salin No. Rekening</span>
								</button>
							</div>
						</div>

						<div class="text-center mb-4" v-if="isOutsourceBankTransferUnpaid">
							<div>Konfirmasikan pembayaran Anda di: <span class="text-bold text-primary cursor-pointer" @click="goToPaymentConfirmation">Konfirmasi Pembayaran</span></div>
						</div>
					</div>
				</div>

				<div class="not-found text-center py-4" v-else-if="!privateOrder && !isLoading">
					<img src="/img/not_found.png" :width="250" alt="">
					<h3>Oops. . . Order tidak ditemukan!</h3>
					<button
						class="btn btn-primary"
						@click.prevent="back()"
					>
						{{ $t('Kembali') }}
					</button>
				</div>
			</div>
		</div>

		<main-footer />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import submissionApi from '@/api/submissions';
import MainFooter from '@/components/homepages/Footer.vue';
import Shimmer from '@/components/Shimmer.vue';
import {
	copyToClipboard,
	duplicateVar,
	formatMoney,
	getAxiosErrorMessage,
	showMidtransSnap,
} from '@/lib/helper';
import { ostockBankAccount } from '@/lib/statics';

export default {
	components: {
		MainFooter,
		Shimmer,
	},
	data() {
		return {
			isLoading: false,
			privateOrder: null,
			isSnapShown: false,
			paymentChecker: null,
			bankAccount: duplicateVar(ostockBankAccount),
		};
	},
	methods: {
		getPrivateOrder(loadingEnabled = true) {
			this.isLoading = loadingEnabled;

			const params = {
				pid: this.pid,
			};

			const callback = (response) => {
				const result = response.data;
				if (result[0]) {
					this.privateOrder = result[0];
				}
				this.isLoading = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Get Wholesale Order Data',
					text: message || 'Something went wrong',
				});
				this.isLoading = false;
			};

			submissionApi.listWholesaleOrder(params, callback, errorCallback);
		},
		copyTotalPrice() {
			copyToClipboard(this.totalPrice);

			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Success',
				text: 'Total Price has been copied.',
			});
		},
		copyAccountNumber() {
			copyToClipboard(this.bankAccount.account_number);

			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Success',
				text: 'Account Number has been copied.',
			});
		},
		getTotalPrice() {
			return formatMoney(this.totalPrice);
		},
		back() {
			this.$router.go(-1);
		},
		setAsPaid() {
			this.privateOrder.payment.status = 'paid';
		},
		closeSnapMidtrans() {
			if (window.snap) {
				window.snap.hide();
			}
		},
		midtransCallback(status, result) {
			console.log(result);
			if (status === 'success') {
				console.log(status, result);
				this.setAsPaid();
			} else if (status === 'pending') {
				const pdfUrl = result.pdf_url;
				console.log(status, pdfUrl);
				window.open(pdfUrl, '_blank');
				this.closeSnapMidtrans();
			} else if (status === 'error') {
				console.log(status);
			} else if (status === 'close') {
				console.log(status);
			}

			this.clearIntervalPaymentChecker();
		},
		clearIntervalPaymentChecker() {
			if (this.paymentChecker) {
				clearInterval(this.paymentChecker);
			}
		},
		startPaymentChecker() {
			const statusChecker = () => {
				this.getPrivateOrder(false);
				if (this.isPaid) {
					this.setAsPaid();
					this.closeSnapMidtrans();
					this.clearIntervalPaymentChecker();
				}
			};
			this.paymentChecker = setInterval(statusChecker, 2000);
		},
		pay() {
			const token = this.privateOrder?.payment?.data?.snap_token ?? '';
			showMidtransSnap(token, this.midtransCallback);
			this.startPaymentChecker();
		},
		goToPaymentConfirmation() {
			this.$router.push({
				name: 'payment-confirmation',
				query: {
					pid: this.pid,
				},
			});
		},
		checkFeature() {
			if (this.user) {
				const isAllowed = this.isDropshipper;
				if (!isAllowed) {
					this.$router.replace('/');
				}
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isHasFeature: 'isHasFeature',
			isDropshipper: 'isDropshipper',
		}),
		pid() {
			return this.$route.query.pid;
		},
		productName() {
			return this.privateOrder?.product_data?.name ?? '';
		},
		totalPrice() {
			return this.privateOrder?.total_price ?? 0;
		},
		paymentMethod() {
			return this.privateOrder?.payment?.method ?? 'bank_transfer';
		},
		paymentStatus() {
			return this.privateOrder?.payment?.status ?? 'unpaid';
		},
		isPaid() {
			return this.paymentStatus === 'paid';
		},
		isBankTransferUnpaid() {
			return this.paymentMethod === 'bank_transfer' && this.paymentStatus === 'unpaid';
		},
		isInstantUnpaid() {
			return this.paymentMethod === 'instant' && this.paymentStatus === 'unpaid';
		},
		isOrderTypeOutsource() {
			return this.privateOrder?.order_type === 'outsource';
		},
		isOrderTypeBulky() {
			return this.privateOrder?.order_type === 'bulky';
		},
		isOutsourceBankTransferUnpaid() {
			return this.isBankTransferUnpaid && this.isOrderTypeOutsource;
		},
		paymentLabel() {
			return this.isOrderTypeBulky && !this.isPaid ? 'pembelianmu' : 'pembayaranmu';
		},
	},
	watch: {
		privateOrder(_, oldValue) {
			if (oldValue === null && this.isInstantUnpaid) {
				this.pay();
			}
		},
		user() {
			this.checkFeature();
		},
	},
	mounted() {
		this.checkFeature();
		this.getPrivateOrder();
	},
	beforeDestroy() {
		this.clearIntervalPaymentChecker();
	},
};
</script>
